/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React from 'react';
import { Button, Container, CssBaseline, Grid } from '@mui/material';
import useStyles from '../../../assets/styles/pages/Shops';
import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';

// import img
import MainShop from '../../../components/MainShop';

// import svg
import { ReactComponent as IconCardOra } from '../../../assets/images/svg/shops/icon_carteora.svg';
import { ReactComponent as IconLocation } from '../../../assets/images/svg/shops/icon_local.svg';
import { ReactComponent as IconAbount } from '../../../assets/images/svg/shops/icon_info.svg';
import { ReactComponent as IconTime } from '../../../assets/images/svg/shops/icon_time.svg';

import { useShopContext } from '../../../providers/use-shop';

const AboutShop: React.FC = () => {
  const classeStyle = useStyles();
  const { data } = useShopContext();

  const openMaps = (latitude: string, longtude: string): any => {
    const link = document.createElement('a');

    link.href = `https://www.google.com/maps/search/${latitude}+${longtude}/@${latitude},${longtude}z`;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Abount" />
      <CssBaseline />
      {data.shop && (
        <>
          <MainShop />
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            marginBottom="100px"
          >
            <Grid container item justifyContent="center" alignItems="center">
              <Grid className={classeStyle.gridAbountMain}>
                <Grid className={classeStyle.gridAbount}>
                  <IconLocation />
                  <h3 className={classeStyle.titleAbount}>Endereço</h3>
                </Grid>
                <Grid>
                  <Button
                    onClick={() =>
                      openMaps(data.shop.nrLatitude, data.shop.nrLongitude)
                    }
                  >
                    <p className={classeStyle.textBtnLocationMap}>
                      {' '}
                      Ver no mapa
                    </p>
                  </Button>
                </Grid>
              </Grid>
              <Grid
                container
                item
                justifyContent="center"
                alignItems="center"
                marginBottom="20px"
              >
                <p className={classeStyle.textDesLocation}>
                  {data.shop.dsEndereco}
                </p>
              </Grid>
            </Grid>
            {data.shop.dsDescricao && (
              <Grid container item justifyContent="center" alignItems="center">
                <Grid className={classeStyle.gridAbountMain}>
                  <Grid className={classeStyle.gridAbount}>
                    <IconAbount />
                    <h3 className={classeStyle.titleAbount}>Sobre o local</h3>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                  marginBottom="20px"
                >
                  <p className={classeStyle.textDesLocation}>
                    {data.shop.dsDescricao}
                  </p>
                </Grid>
              </Grid>
            )}
            {data.shop?.arrHorarios.length > 0 && (
              <Grid
                container
                item
                justifyContent="center"
                alignItems="center"
                marginBottom={3}
              >
                <Grid className={classeStyle.gridAbountMain}>
                  <Grid className={classeStyle.gridAbount}>
                    <IconTime width={18} height={19} />
                    <h3 className={classeStyle.titleAbount}>
                      Horários de Funcionamento
                    </h3>
                  </Grid>
                </Grid>
                {data.shop.arrHorarios.map((item: any) => (
                  <Grid
                    container
                    item
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    marginLeft="35px"
                    marginBottom="3px"
                    className={classeStyle.gridAbountMain}
                    key={item.dia}
                  >
                    <p className={classeStyle.titleDayOperation}>{item.dia}</p>
                    <Grid>
                      {item.horarios.map((hours: any, index: any) => (
                        <p
                          className={classeStyle.textHoursOperation}
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                        >
                          {hours}
                        </p>
                      ))}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
            <Grid container item justifyContent="center" alignItems="center">
              <Grid className={classeStyle.gridAbountMain}>
                <Grid className={classeStyle.gridAbount}>
                  <IconCardOra />
                  <h3 className={classeStyle.titleAbount}>
                    Formas de pagamento
                  </h3>
                </Grid>
              </Grid>
              {data.shop.pagamentos.length > 0 &&
                data.shop.pagamentos.map((item: any) => (
                  <Grid
                    container
                    item
                    justifyContent="flex-start"
                    alignItems="center"
                    marginLeft="35px"
                    className={classeStyle.gridAbountMain}
                    key={item.idPagamento}
                  >
                    <p className={classeStyle.textDesFormatPayment}>
                      {item.dsPagamento}
                    </p>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </>
      )}
      <FooterMenuMain />
    </Container>
  );
};

export default AboutShop;
